import router from '@/router';
import { authService } from '@/services/tmed-plans/auth.service';
import { isPrivateMode } from '@/utils/app-mode';

export default {
  namespaced: true,
  state: {
    userRequestStatus: 'init',
    userReqBtnStatus: 'init',
    user: {},
  },
  getters: {
    // STATUS
    getUserResquestStatus(state) {
      return state.userRequestStatus;
    },
    getUserReqBtnStatus(state) {
      return state.userReqBtnStatus;
    },
    getUserDetails(state) {
      return state.user;
    },
    getUserFromStorage(state) {
      let fromStorage = {};
      try {
        const raw = localStorage.getItem('user');
        if (raw) fromStorage = JSON.parse(raw) || {};
      } catch {
        fromStorage = {};
      }
      return { ...state.user, ...fromStorage };
    },
  },
  mutations: {
    // STATUS
    USER_STATUS(state, value) {
      state.userRequestStatus = value;
    },
    USER_REQ_BTN_STATUS(state, value) {
      state.userReqBtnStatus = value;
    },
    CLEAR_LOGGED_USER() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      localStorage.clear();
    },
    SET_USER(state, user) {
      state.user = user;
    },
  },
  actions: {
    async doLogout({ commit }) {
      commit('CLEAR_LOGGED_USER', 'clear');

      var cookies = document.cookie.split(';');

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var pos = cookie.indexOf('=');
        var nome = pos > -1 ? cookie.substr(0, pos) : cookie;
        document.cookie = nome + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
      const loginPath = isPrivateMode() ? '/cb/login' : '/login';
      router.push(loginPath).catch(() => {});
    },
    async doForgotPassword({ commit }, email) {
      commit('USER_STATUS', 'pending');
      try {
        const { data } = await authService.forgotPassword(email);
        commit('USER_STATUS', 'init');
        return data;
      } catch (error) {
        commit('USER_STATUS', 'init');
        throw error;
      }
    },
    async doResetPassword({ commit }, { email, code, password }) {
      commit('USER_STATUS', 'pending');
      try {
        const { data } = await authService.resetPassword({ email, code, password });
        commit('USER_STATUS', 'init');
        return data;
      } catch (error) {
        commit('USER_STATUS', 'init');
        throw error;
      }
    },
    async doChangePassword({ commit }, params) {
      commit('USER_STATUS', 'pending');
      try {
        const { data } = await authService.changePassword(params);
        commit('USER_STATUS', 'init');
        return data;
      } catch (error) {
        commit('USER_STATUS', 'init');
        throw error;
      }
    },
    async loginUser({ commit }, params) {
      commit('USER_STATUS', 'pending');
      try {
        const { data } = await authService.loginUser(params);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('refreshToken', data.refreshToken);
        localStorage.setItem('token', data.idToken);
        commit('USER_STATUS', 'init');
        commit('SET_USER', data.user);
        return data;
      } catch (error) {
        commit('USER_STATUS', 'init');
        throw error;
      }
    },
    async refreshToken({ commit, dispatch }, payload) {
      commit('USER_STATUS', 'pending');
      try {
        const { data } = await authService.refreshToken(payload);
        localStorage.setItem('refreshToken', data.refreshToken);
        localStorage.setItem('token', data.idToken);
        commit('USER_STATUS', 'init');
        setTimeout(() => {
          location.reload();
        }, 2000);
      } catch (error) {
        commit('USER_STATUS', 'init');
        setTimeout(() => {
          dispatch('doLogout');
        }, 5000);
        throw error;
      }
    },
  },
};
